<template>
  <a-modal v-model="visibleProgress" centered :closable="false" @cancel="visibleProgress = false">
    <div class="mt-10">
      <div v-if="percent === 100" class="text-success">PDF was successfully downloaded.</div>
      <div v-if="percent < 100" class="text-primary">Downloading...</div>
      <a-progress :percent="percent" size="small" />
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "ModalProgress",
  data() {
    return{
      visibleProgress : false,
      percent         : 0,
    }
  }
}
</script>

<style scoped>

</style>
